import { djangoApi } from "../utils/axios/axios.utils";

const AUTH_HEADERS = {
	headers: {
		Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
		"Content-Type": "multipart/form-data",
	},
};

export async function fetchManagerPersonalizedFinancialMetrics(params = {}) {
	const { data } = await djangoApi.get(
		"products/manager/personalized-orders/financial-metrics/",
		{
			params,
			...AUTH_HEADERS,
		}
	);
	return data;
}

export async function fetchManagerPersonalizedOrderSummary(params = {}) {
	const { data } = await djangoApi.get(
		"products/manager/personalized-orders/transactions/summary-by-order/",
		{
			params,
			...AUTH_HEADERS,
		}
	);
	return Array.isArray(data) ? data : [];
}

export async function fetchManagerPersonalizedTransactions(params = {}) {
	const { data } = await djangoApi.get(
		"products/manager/personalized-orders/transactions/",
		{
			params,
			...AUTH_HEADERS,
		}
	);
	return Array.isArray(data) ? data : [];
}

export async function updateManagerPersonalizedOrderPaymentChecked(
    orderId,
    isPaymentChecked
) {
    const { data } = await djangoApi.patch(
        `products/manager/personalized-orders/${orderId}/payment-checked/`,
        {
            is_payment_checked: Boolean(
                isPaymentChecked
            ),
        },
        {
            headers: {
                Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                "Content-Type": "application/json",
            },
        }
    );

    return data;
}